import ApiService from "../../../../../services/ApiService";
import translate from "../../../../../services/Translate";

export const getMeetingReminderTemplates = (
  meetingTypeId: string,
  setReminderTemplates: Function,
  setLoadingMeetingReminderTemplates: Function,
  language: string
) => {
  setLoadingMeetingReminderTemplates(true);
  ApiService.get(`meetings/types/${meetingTypeId}/reminders/templates`)
    .then((response) => setReminderTemplates(response.data.meeting_reminder_templates))
    .catch((error) => {
      console.error("Failed to get meeting reminder templates:", error);
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.TEMPLATE_REMINDER.ALERTS.ERROR_FETCHING_TEMPLATES"));
    })
    .finally(() => setLoadingMeetingReminderTemplates(false));
};

export const sendMeetingReminder = (
  meetingId: string,
  payload: {
    user_ids: number[];
    template_content: string;
    subject?: string;
  },
  language: string,
  setIsSendingReminder: Function,
  successCallback?: Function
) => {
  setIsSendingReminder(true);
  ApiService.post(`meetings/${meetingId}/reminders`, payload)
    .then(() => {
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.TEMPLATE_REMINDER.ALERTS.SUCCESS_SENDING"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Failed to send meeting reminder:", error);
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.TEMPLATE_REMINDER.ALERTS.ERROR_SENDING"));
    })
    .finally(() => setIsSendingReminder(false));
};
